import React, { useState, useEffect } from "react";
import {
  Modal,
  Card,
  List,
  ListItem,
  ListItemText,
  Typography,
  Icon,
  Divider,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { getEquipmentUsers } from "../services/userEquipmentService";

const EquipmentUsersModal = ({ open, onClose, serialNumber }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "600px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
    maxHeight: "95vh",
  };

  useEffect(() => {
    if (open && serialNumber) {
      fetchUsers();
    }
  }, [open, serialNumber]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const result = await getEquipmentUsers(serialNumber);
      if (result.success) {
        setUsers(result.data);
      }
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Card sx={style}>
        <MDBox
          mt={-7}
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          p={2}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Typography component="h2">Usuarios con este equipo</Typography>
          <Icon
            sx={{
              fontSize: "2em",
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={onClose}
          >
            close
          </Icon>
        </MDBox>
        <Divider variant="middle" />
        <div style={{ maxHeight: "80%", overflowY: "auto" }}>
          <MDBox p={2}>
            {loading ? (
              <MDTypography>Cargando...</MDTypography>
            ) : (
              <>
                <MDTypography variant="body2" mb={2}>
                  Serie: {serialNumber}
                </MDTypography>
                <List>
                  {users.map((user) => (
                    <ListItem key={user.id}>
                      <ListItemText
                        primary={`${user.card_user.name} ${user.card_user.lastname}`}
                        secondary={` Registrado: ${new Date(
                          user.registered_at
                        ).toLocaleDateString()}`}
                      />
                    </ListItem>
                  ))}
                </List>
              </>
            )}
          </MDBox>
        </div>
        <Divider variant="middle" />
        <MDBox
          style={{
            display: "flex",
            justifyContent: "space-around",
          }}
          m={-0.5}
          mb={-2}
        >
          <MDButton color="error" onClick={onClose}>
            Cerrar
          </MDButton>
        </MDBox>
      </Card>
    </Modal>
  );
};

export default EquipmentUsersModal;
